import PropTypes from "prop-types";
import React, { useContext, useEffect, useState } from "react";

import { tabsName } from "../const";
import { InvoiceTemplateContext } from "../InvoiceTemplateContext";

const SelectableElement = ({ as: Tag = "span", id, stylePath, ...props }) => {
  const [selectable, setSelectable] = useState(false);
  const { dispatch, state } = useContext(InvoiceTemplateContext);

  const [selected, setSelected] = useState(() => {
    return Boolean(state.selectedElements.find(e => e.id === id));
  });

  const handleClick = event => {
    if (selectable) {
      dispatch({ type: "selectElement", payload: { id, stylePath } });
      setSelected(!selected);
    }
  };

  useEffect(() => {
    setSelected(Boolean(state.selectedElements.find(e => e.id === id)));
  }, [id, state.selectedElements]);

  useEffect(() => {
    setSelectable(state.activeTab === tabsName.general);
  }, [state.activeTab]);

  return (
    <Tag
      // @ts-ignore
      onClick={handleClick}
      className={`${selectable && "selectable-element"} ${
        selected && "selected"
      }`}
      {...props}
    />
  );
};

SelectableElement.propTypes = {
  as: PropTypes.elementType,
  children: PropTypes.node,
  id: PropTypes.string,
  stylePath: PropTypes.string,
};

export default SelectableElement;
